<template>
<div class="container custom_container">
    <div class="row dashboard_content_wrap">
        <div class="col_12">
            <div class="common_title">
                <h2>Dashboard</h2>
            </div>
        </div>
        <div class="col_12">
            <div class="dashboard_content">
                <div class="dashboard_content_inner">
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Total Visitor</h3>
                            </div>
                            <p><span> </span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Yesterday Visitor</h3>
                            </div>
                            <p><span> </span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Today Visitor</h3>
                            </div>
                            <p><span> </span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Last 30 days Visitor</h3>
                            </div>
                            <p><span> </span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Total Customer</h3>
                            </div>
                            <p><span> </span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Total Page</h3>
                            </div>
                            <p><span> </span> <span></span></p>
                            <span class="sales_number">5</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Total News</h3>
                            </div>
                            <p><span></span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>
                    <div class="inner">
                        <div class="inner_content">
                            <div class="common_subtitle">
                                <h3>Total Notice</h3>
                            </div>
                            <p><span></span> <span></span></p>
                            <span class="sales_number">0</span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            baseUrl: process.env.VUE_APP_BASE,
            totalSaleAmount: 0,
            totalSaleCount: 0,
            totalInCart: 0,
            totalInCartAmount: 0,
            latestOrders: [],
            totalVisitorToday: 0,
            currentVisitorwFb: 0,
            inactiveVideos: [],
            totalCurrentLivevisitor: 0,
            webLive: 0,
        }
    },
    created() {

    },
    computed: {
      
    },
    methods: {
        
    }
}
</script>
